import React from 'react';
import styles from './Spinner.module.css';

function Spinners() {
  return (
    <div className={styles.spinner}>
      <div className={styles.inner__spinner}></div>
    </div>
  );
}

export default Spinners;
